module.exports = __webpack_public_path__ + "e35fc4251ec06f7d2abeced22bda3458.svg";